import { type LegacyOrderDraftConstructorData } from '../../entities/LegacyOrderDraft'
import { type LegacyOrderDraftApiModel } from '../api-models/LegacyOrderDraftApiModel'

const mapPunchOutSupplier = (punchoutSupplierData: {
  punchout_supplier_icon: Nullable<string>
  punchout_supplier_name: Nullable<string>
  punchout_vendor_reference: Nullable<number>
}) => {
  if (
    !punchoutSupplierData.punchout_supplier_icon ||
    !punchoutSupplierData.punchout_supplier_name ||
    punchoutSupplierData.punchout_vendor_reference === null
  )
    return null

  return {
    id: punchoutSupplierData.punchout_vendor_reference,
    icon: punchoutSupplierData.punchout_supplier_icon,
    name: punchoutSupplierData.punchout_supplier_name,
  }
}

export const mapLegacyOrderDraftApiModel = (
  orderDraft: LegacyOrderDraftApiModel
): LegacyOrderDraftConstructorData => ({
  uuid: orderDraft.uuid,
  attachments: orderDraft.attachments,
  dateRequired: orderDraft.dateRequired,
  description: orderDraft.description,
  primaryCategory: orderDraft.location
    ? {
        id: orderDraft.location.id,
        name: orderDraft.location.name,
      }
    : null,
  punchoutGroup: orderDraft.punchout_group,
  punchoutShippingAddress: orderDraft.punchout_shipping_address,
  punchoutSupplier: mapPunchOutSupplier(orderDraft),
  secondaryCategory: orderDraft.department
    ? {
        id: orderDraft.department.id,
        name: orderDraft.department.name,
      }
    : null,
  status: orderDraft.status,
})
